import $ from 'jquery';
import _debounce from 'lodash/debounce';
import { buildSlider, destroySlider } from '../utils/slider';

export default $related => {
    if ($('.product').length || $('.subscription').length) {
        return;
    }

    const settings = {
        slidesToShow: 1,
        prevArrow:
            '<button class="related-products__prev"><i class="icon-arrow-prev"></i></button>',
        nextArrow:
            '<button class="related-products__next"><i class="icon-arrow-next"></i></button>',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };

    if ($(window).width() < 960) {
        buildSlider($related, settings);
    }

    $(window).on(
        'resize',
        _debounce(() => {
            if ($(window).width() < 960) {
                buildSlider($related, settings);
            } else {
                destroySlider($related);
            }
        }, 100),
    );
};
